interface TextAnalysisTemplate {
  toolName: string
  source: string
  userType: string
  collectionIndex: string
  orderBy: string
  orderDirection: 'desc' | 'asc'
  attributeTitle: string
  attributeDesc: string
}

export const textAnalysisTemplate: TextAnalysisTemplate = {
  toolName: 'text_analysis',
  source: 'ehq',
  userType: 'user',
  collectionIndex: 'ehq-contributions-alias',
  orderBy: 'metadata.created_at',
  orderDirection: 'desc',
  attributeTitle: 'title',
  attributeDesc: 'description',
}
